import CompletePasswordResetForm from "../../ui/complete-password-reset-form";

const CompletePasswordResetPage = () => {
  return <CompletePasswordResetForm />;
};

export default CompletePasswordResetPage;